export const FULFILLED = (actionName: string) => `${actionName}_FULFILLED`
export const PENDING = (actionName: string) => `${actionName}_PENDING`
export const REJECTED = (actionName: string) => `${actionName}_REJECTED`
